var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "akl" }, [
    _c("div", { staticClass: "bod-view-txt" }, [
      _c("div", { staticClass: "os_noticeRes taola_wrap" }, [
        _c(
          "div",
          { staticClass: "widM padTM cont_Wrap" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "NCACroa_cont01_wrap mo_widM mo_padBS" }, [
              _c("div", { staticClass: "clearfix" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "NCACroa_cont01-1 padBM padTM NCACroa_cont01_input"
                  },
                  [
                    _c("span", { staticClass: "fntP bold" }, [_vm._v("이름")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fntP bold colorRightGray" }, [
                      _vm._v(_vm._s(this.reservationInfo.user_name))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "NCACroa_cont01-1 padBM padTM NCACroa_cont01_input"
                  },
                  [
                    _c("span", { staticClass: "fntP bold" }, [
                      _vm._v("ABO번호")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fntP bold colorRightGray" }, [
                      _vm._v(_vm._s(this.reservationInfo.user_id))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "NCACroa_cont01-1 padBM padTM NCACroa_cont01_input"
                  },
                  [
                    _c("span", { staticClass: "fntP bold" }, [
                      _vm._v("신청 세션")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fntP bold colorRightGray" }, [
                      _vm._v(
                        "<" + _vm._s(this.reservationInfo.event.title) + "> "
                      ),
                      _c("b", [
                        _vm._v(_vm._s(this.reservationInfo.event.session_name))
                      ]),
                      _vm._v(
                        " " + _vm._s(this.reservationInfo.event.session_time)
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "widM txtC marTML" }, [
              _c(
                "button",
                {
                  staticClass: "bt-akl-blue large NCACroa_submit",
                  attrs: {
                    disabled: this.reservationInfo.event.eventPeriod === "N",
                    id: "addToCart"
                  },
                  on: { click: _vm.showCancelPopup }
                },
                [_vm._v("신청 취소하기")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "fntE txtL bold marTS",
                  staticStyle: { color: "#d91734" }
                },
                [
                  _vm._v(
                    "* 세션변경을 원하실 경우 신청 취소 후 다시 신청해 주세요."
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "padM disIb" }),
            _vm._v(" "),
            _vm.isCancelPopup
              ? _c("WouldUrideCancelConfrim", {
                  attrs: { cancelEndPointData: _vm.cancelEndPointData },
                  on: {
                    popupClose: _vm.isPopupClose,
                    cancelConfirm: _vm.frontCancelReservation
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("Loading", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isLoading,
                  expression: "this.isLoading"
                }
              ]
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "txtC padBM",
        staticStyle: { "border-bottom": "1px solid #ddd" }
      },
      [
        _c("img", {
          staticClass: "icoS",
          staticStyle: { "max-width": "115px" },
          attrs: {
            src:
              "https://www.amway.co.kr/_ui/_noticeImg/logo/logo_amway_ci.png",
            alt: "Amway (로고)"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "taola_completion_box marTML marBS padTL padBL mo_widM" },
      [
        _c("div", { staticClass: "taola_completion_con" }, [
          _c("img", {
            attrs: { src: require("../_images/ico_completion.png") }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "taola_completion-title fntH5" }, [
            _vm._v("신청이 완료되었습니다.")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "taola_completion-txt" }, [
            _vm._v("아래 신청 내용을 확인해 주세요.")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bbb26ca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bbb26ca","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/taola/wouldUride/WouldUrideTaolaReservationComplete.vue
// module id = null
// module chunks = 